import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DetailsProfilRoutingModule } from './details-profil-routing.module';
import { ProfilEsnComponent } from './components/profil-esn/profil-esn.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelephoneInputModule } from 'ngx-intl-telephone-input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyReviewsComponent } from './components/my-reviews/my-reviews.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FieldErrorModule } from '@shared/components/shared-field-error/field-error.module';
import { CalendarModule } from 'primeng/calendar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from 'app/shared/shared.module';
import { EditProfileEsnComponent } from './components/edit-profile-esn/edit-profile-esn.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    ProfilEsnComponent,
    MyReviewsComponent,
    EditProfileEsnComponent

  ],
  imports: [
    CommonModule,
    DetailsProfilRoutingModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    NgxIntlTelephoneInputModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    FormsModule,
    RatingModule.forRoot(),
    FieldErrorModule,
    CalendarModule,
    SharedModule,
    MatTooltipModule
  ]
})
export class DetailsProfilModule { }
